import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=41ad176e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ad176e')) {
      api.createRecord('41ad176e', component.options)
    } else {
      api.reload('41ad176e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=41ad176e&", function () {
      api.rerender('41ad176e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24LP8l758n1Kf/JS/comp/ImgFallback.vue"
export default component.exports